import { MeetingRoomDlCreateRequest } from "../../model/meetingRoomDlCreateRequest";
import { fetchPostJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = MeetingRoomDlCreateRequest;

export async function postMeetingRoomDls(payload: DtoType) {
  try {
    const url = apiUrls.postMeetingRoomDls;
    return await fetchPostJSON(url, payload);
  } catch (err) {
    console.error("API Error - postMeetingRoomDls:", err);
  }
}
